import { dynamicRoutes, staticRoutes } from "@/router";
import { getMenus } from "@/service/common/menu";
import { menusToRouter } from "@/utils/common";
import { createStore } from "vuex";

export default createStore({
  state: {
    token: "",
    refreshToken: "",
    user: "",
    routes: [], //全部路由
    addRoutes: [], //后端增加的路由
    rule: [], //权限
  },
  getters: {
    // getBearerToken(state) {
    //   return state.token ? "Bearer " + state.token : "";
    // },
    getToken(state) {
      if (!state.token) {
        state.token = localStorage.getItem("TOKEN");
      }
      return state.token;
    },
    getUser(state) {
      if (!state.user) {
        state.user = localStorage.getItem("USER");
      }
      return state.user;
    },
    getIsLogin(state) {
      // return state.token !== null && state.user !== null && new Date(state.token?.expireTime) > new Date()
      return state.token !== null && state.user !== null;
    },
  },
  mutations: {
    // 设置令牌token
    setToken: (state, token) => {
      state.token = token;
      localStorage.setItem("TOKEN", token);
    },
    // 设置用户信息
    setUser: (state, user) => {
      state.user = user;
      localStorage.setItem("USER", user);
    },
  },
  actions: {
    // 登录
    login({ commit }, { token, user }) {
      commit("setToken", token);
      commit("setUser", user);
    },
    // 退出
    logout({ commit }) {
      commit("setToken", "");
      commit("setUser", "");
      this.state.routes = [];
      this.state.addRoutes = [];
      localStorage.clear();
    },
    // 菜单
    generateRoutes(routes) {
      let routerList = JSON.parse(JSON.stringify(routes));
      return new Promise((resolve) => {
        // 请求后端菜单数据
        getMenus().then((res) => {
          if (res) {
            // 格式化菜单
            const accessedRoutes = menusToRouter(res.data.menu);
            // 添加公共路由
            const commonRoutes =
            {
              path: "/perview",
              name: "Perview",
              meta: {
                icon: '',
                title: 'Perview',
                hidden: true
              },
              component: () => import("@/views/Perview.vue"),
              redirect: '',
              children: [],
            }

            accessedRoutes.push(commonRoutes)
            // error
            accessedRoutes.push(
              {
                path: "/:pathMatch(.*)",
                name: "404",
                meta: {
                  icon: '',
                  title: '404',
                  hidden: true
                },
                component: () => import("@/views/error/404.vue"),
              }
            )
            // 添加到动态路由中
            dynamicRoutes[0].children = accessedRoutes;
            // 赋值
            this.state.addRoutes = accessedRoutes;
            this.state.routes = staticRoutes.concat(dynamicRoutes);
            // 权限标识
            this.state.rule = res.data.role;
            resolve(accessedRoutes);
          }
        });
      });
    },
  },
  modules: {},
});
